import { SofiaEnvironment } from "@/sofia-environment"

const {
  Bff: { Url: bffHost, Credentials: credentials },
} = SofiaEnvironment

const genesysTelephonyLoginUrl = `${bffHost}/bff/genesys-telephony-login?returnUrl=/genesys-telephony-logged-in`

const genesysTelephonyLoggedMessageAction = "genesys-telephony-logged"

const isGenesysTelephonyLoggedMessage = (event: MessageEvent<{ action?: string } | null>, loginWindow: Window) =>
  event.source === loginWindow &&
  event.origin === window.location.origin &&
  event.data?.action === genesysTelephonyLoggedMessageAction

const genesysTelephonyCheckValidity = async () => {
  const response = await fetch(`${bffHost}/bff/genesys-telephony-silent-login`, {
    method: "GET",
    credentials: credentials,
  })

  return response.status === 200
}

export {
  genesysTelephonyLoginUrl,
  genesysTelephonyLoggedMessageAction,
  isGenesysTelephonyLoggedMessage,
  genesysTelephonyCheckValidity,
}
